import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ForKids icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ForKids } from '@sravni/design-system-icons'
 *
 * <ForKids />
 * ```
 */
var ForKids = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ForKids", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.806 5.14h-.973v-.973c0-.921.746-1.667 1.667-1.667h.973v.973c0 .92-.747 1.666-1.667 1.666v0ZM10.833 10.833A3.254 3.254 0 0 1 7.58 7.58M7.58 7.58c0-1.42.65-2.442 1.952-2.442M10.833 10.833a3.254 3.254 0 0 0 3.255-3.254", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.088 7.58c0-1.42-.651-2.442-1.953-2.442M12.135 5.14c-.65 0-1.02.207-1.302.207-.281 0-.65-.208-1.301-.208M17.188 10.833H6.146a1.666 1.666 0 1 0 0 3.334h11.041M16.767 10.833v3.334M15.52 14.167H4.48a1.666 1.666 0 1 0 0 3.333h11.04M15.1 14.167V17.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ForKids };
//# sourceMappingURL=ForKids.js.map
